import { Outlet } from "react-router";
import { Header } from "./Header";
import { Footer } from "./Footer";
interface LayoutProps {
  isLoginPage?: boolean;
}


export const Layout: React.FC<LayoutProps & { children: React.ReactNode }> = ({ children, isLoginPage = false }) => {
  return (
    <div className="min-h-screen bg-background">
      <Header 
        isLoginPage={isLoginPage} // Pass the isLoginPage prop to Header
      />
      <div className="flex h-[calc(100vh-4rem)] pt-16">
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto h-full pt-4">
            {children}
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}